import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "mercader",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  // Tasa fija anual del arrendamiento puro (hoja "TABLA AMORT AP"). Solo para la estimación del cotizador: la
  // tasa real la asigna el modelo en la oferta.
  interest_rate: 25,
  comision: 3,
  iva: 16,
  // Razones sociales de los textos legales (autorizaciones SAT/Buró, aviso de evaluación), como el prototipo (QA MAR-01).
  companyNames: ["Mercader Financial SA SOFOM ER", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_1JlDETH0R",
      userPoolClientId: "1abge4gf9is5is4he9r538jfj0",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "",
      userPoolClientId: "",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
